var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription-block"},[_c('subscribe',{attrs:{"has-title":false,"is-standalone":true,"description-field":_vm.descriptionField,"cta-appearance":_vm.ctaAppearance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }